import axios from 'axios';

export const getTipsterFeeTiers = (data: any) => {
  return axios.get(`/v1/tipsters/fee_tiers`);
};

export const getSalesRequest = (query: {
  period_filter: string;
  cursor?: string;
  type_filter: string;
  limit: number;
  start_date?: string;
  end_date?: string;
}) => {
  const { period_filter, cursor, type_filter, limit = 50, start_date, end_date } = query;
  
  // Build base URL
  let url = `/v1/me/sales?period_filter=${period_filter}&income_source=${type_filter}`;
  
  // Add cursor if present
  if (cursor) {
    url += `&cursor=${cursor}`;
  }
  
  // Add start_date and end_date if present (for CUSTOM period)
  if (start_date) {
    url += `&start_date=${encodeURIComponent(start_date)}`;
  }
  if (end_date) {
    url += `&end_date=${encodeURIComponent(end_date)}`;
  }
  
  // Add limit
  url += `&limit=${limit}`;
  
  return axios.get(url);
};

export const getBalanceRequest = (query: any) => {
  const cursor = query.cursor;
  return cursor === undefined
    ? axios.get(`/v1/me/balance?limit=50`)
    : axios.get(`/v1/me/balance?cursor=${cursor}&limit=50`);
};

export const getStatsRequest = (query: { period_filter: string }) => {
  const { period_filter } = query;
  return axios.get(`/v1/me/users_stats?period_filter=${period_filter}`);
};

export const editPayoutMethodRequest = (data: any) => {
  return axios.put(`/v1/me/payout_method`, data);
};
export const requestPayout = (amount: number) => {
  return axios.put(`/v1/me/payouts/request`, { amount });
};

export const cancelPayout = (payoutId: string) => {
  return axios.delete(`/v1/payouts/${payoutId}`, {
    data: { by_user: true }
  });
};
